import { Calendar, Eye, User, TrendingUp, Flame, Clock, Search as SearchIcon, BookOpen, Star } from "lucide-react";
import { motion } from "framer-motion";
import { useState } from "react";


const SectionBlogList = () => {
  const [activeCategory, setActiveCategory] = useState("Tất cả");
 const blogPosts2 = [
    {
      id: 1,
      title: "10 Xu hướng thiết kế website năm 2024",
      description: "Khám phá những xu hướng thiết kế website mới nhất và cách áp dụng chúng vào dự án của bạn...",
      image: "https://i0.wp.com/thuthuatphanmem.vn/uploads/2018/08/21/hinh-nen-thien-nhien-phong-canh-dep-4_043141001.jpg",
      author: "TrioCore Solutions Team",
      date: "15/09/2024",
      views: "1.2K",
      tags: ["Design", "Trend", "UI/UX"],
      category: "Thiết kế"
    },
    {
      id: 2,
      title: "Cách tối ưu SEO hiệu quả cho website",
      description: "Hướng dẫn chi tiết các kỹ thuật SEO on-page và off-page để website của bạn lên top Google...",
      image: "https://i0.wp.com/thuthuatphanmem.vn/uploads/2018/08/21/hinh-nen-thien-nhien-phong-canh-dep-4_043141001.jpg",
      author: "Marketing Team",
      date: "12/09/2024", 
      views: "980",
      tags: ["SEO", "Marketing", "Google"],
      category: "Marketing"
    },
    {
      id: 3,
      title: "React vs Vue.js: Lựa chọn nào phù hợp?",
      description: "So sánh chi tiết giữa React và Vue.js để giúp bạn chọn framework phù hợp cho dự án...",
      image: "https://i0.wp.com/thuthuatphanmem.vn/uploads/2018/08/21/hinh-nen-thien-nhien-phong-canh-dep-4_043141001.jpg",
      author: "Dev Team",
      date: "08/09/2024",
      views: "750",
      tags: ["React", "Vue.js", "Frontend"],
      category: "Lập trình"
    },
    {
      id: 4,
      title: "Bảo mật website: Những điều cần biết",
      description: "Tìm hiểu các biện pháp bảo mật cơ bản và nâng cao để bảo vệ website khỏi các cuộc tấn công...",
      image: "https://i0.wp.com/thuthuatphanmem.vn/uploads/2018/08/21/hinh-nen-thien-nhien-phong-canh-dep-4_043141001.jpg",
      author: "Security Team",
      date: "05/09/2024",
      views: "620",
      tags: ["Security", "SSL", "Firewall"],
      category: "Bảo mật"
    },
    {
      id: 5,
      title: "Tối ưu tốc độ tải trang web",
      description: "Các kỹ thuật và công cụ giúp cải thiện tốc độ tải trang, nâng cao trải nghiệm người dùng...",
      image: "https://i0.wp.com/thuthuatphanmem.vn/uploads/2018/08/21/hinh-nen-thien-nhien-phong-canh-dep-4_043141001.jpg",
      author: "Performance Team",
      date: "02/09/2024",
      views: "890",
      tags: ["Performance", "Optimization", "Speed"],
      category: "Tối ưu"
    },
    {
      id: 6,
      title: "Progressive Web App (PWA) là gì?",
      description: "Tìm hiểu về PWA và cách xây dựng ứng dụng web với trải nghiệm như native app...",
      image: "https://i0.wp.com/thuthuatphanmem.vn/uploads/2018/08/21/hinh-nen-thien-nhien-phong-canh-dep-4_043141001.jpg",
      author: "Tech Team",
      date: "28/08/2024",
      views: "540",
      tags: ["PWA", "Mobile", "Web App"],
      category: "Công nghệ"
    }
  ];

  const categories2 = ["Tất cả", "Thiết kế", "Lập trình", "Marketing", "Bảo mật", "Tối ưu", "Công nghệ"];
  // Featured/Hero Post
  const heroPost = {
    id: 'hero',
    title: "Hướng dẫn toàn diện: Xây dựng website chuyên nghiệp từ A-Z năm 2024",
    description: "Khám phá quy trình hoàn chỉnh để tạo ra một website đẳng cấp với công nghệ hiện đại nhất. Từ thiết kế UI/UX, lựa chọn tech stack, tối ưu SEO, đến deployment và bảo trì. Hướng dẫn chi tiết với code examples và best practices từ các chuyên gia hàng đầu.",
    image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1200&h=600&fit=crop",
    author: "TrioCore Solutions Team",
    authorAvatar: "https://i.pravatar.cc/150?img=1",
    date: "20/10/2024",
    readTime: "15 phút đọc",
    views: "5.2K",
    tags: ["Guide", "Web Development", "Best Practices"],
    category: "Hướng dẫn",
    featured: true
  };

  // Trending Posts
  const trendingPosts = [
    {
      id: 't1',
      title: "10 xu hướng thiết kế UI/UX sẽ thống trị năm 2024",
      image: "https://images.unsplash.com/photo-1559028012-481c04fa702d?w=400&h=300&fit=crop",
      category: "Thiết kế",
      views: "3.2K",
      gradient: "from-purple-500 to-pink-500"
    },
    {
      id: 't2',
      title: "AI và Machine Learning trong Web Development",
      image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400&h=300&fit=crop",
      category: "Công nghệ",
      views: "2.8K",
      gradient: "from-blue-500 to-cyan-500"
    },
    {
      id: 't3',
      title: "Cách tăng 300% tốc độ website với các kỹ thuật đơn giản",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop",
      category: "Tối ưu",
      views: "2.5K",
      gradient: "from-green-500 to-emerald-500"
    }
  ];

  // Main blog posts với nội dung phong phú
  const blogPosts = [
    {
      id: 1,
      title: "Next.js 14: Những tính năng mới đáng chú ý và cách migrate",
      description: "Khám phá Server Actions, Partial Prerendering, và Turbopack trong Next.js 14. Hướng dẫn chi tiết cách upgrade từ version 13 với minimal breaking changes. Phân tích performance improvements và best practices mới nhất.",
      image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=800&h=500&fit=crop",
      author: "Minh Tuấn",
      authorAvatar: "https://i.pravatar.cc/150?img=12",
      date: "18/10/2024",
      readTime: "8 phút",
      views: "1.8K",
      tags: ["Next.js", "React", "Frontend"],
      category: "Lập trình",
      gradient: "from-blue-600 to-cyan-500"
    },
    {
      id: 2,
      title: "SEO 2024: Chiến lược toàn diện để lên TOP Google",
      description: "Cập nhật thuật toán mới nhất của Google, E-E-A-T, Core Web Vitals, và AI-powered search. Hướng dẫn keyword research, on-page SEO, technical SEO, và link building strategies. Case study thực tế với kết quả impressive.",
      image: "https://images.unsplash.com/photo-1432888622747-4eb9a8f2c293?w=800&h=500&fit=crop",
      author: "Thu Hương",
      authorAvatar: "https://i.pravatar.cc/150?img=5",
      date: "17/10/2024",
      readTime: "12 phút",
      views: "2.1K",
      tags: ["SEO", "Marketing", "Google"],
      category: "Marketing",
      gradient: "from-purple-600 to-pink-500"
    },
    {
      id: 3,
      title: "TypeScript: Từ cơ bản đến nâng cao trong 30 ngày",
      description: "Series học TypeScript toàn diện với 30 bài học từ dễ đến khó. Generics, Decorators, Advanced Types, và Integration với React/Vue. Exercises và real-world examples sau mỗi bài. Hoàn toàn FREE!",
      image: "https://images.unsplash.com/photo-1516116216624-53e697fedbea?w=800&h=500&fit=crop",
      author: "Hoàng Nam",
      authorAvatar: "https://i.pravatar.cc/150?img=8",
      date: "16/10/2024",
      readTime: "6 phút",
      views: "1.5K",
      tags: ["TypeScript", "JavaScript", "Tutorial"],
      category: "Lập trình",
      gradient: "from-indigo-600 to-blue-500"
    },
    {
      id: 4,
      title: "Bảo mật Web Application: Prevent Common Vulnerabilities",
      description: "Deep dive vào OWASP Top 10, SQL Injection, XSS, CSRF, và các attack vectors phổ biến. Best practices cho authentication, authorization, data encryption. Tools và frameworks để audit security. Compliance với GDPR và local laws.",
      image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&h=500&fit=crop",
      author: "Đức Anh",
      authorAvatar: "https://i.pravatar.cc/150?img=15",
      date: "15/10/2024",
      readTime: "10 phút",
      views: "1.2K",
      tags: ["Security", "Backend", "DevOps"],
      category: "Bảo mật",
      gradient: "from-red-600 to-orange-500"
    },
    {
      id: 5,
      title: "Microservices Architecture: Design Patterns & Best Practices",
      description: "Kiến trúc microservices từ lý thuyết đến thực hành. API Gateway, Service Discovery, Load Balancing, Circuit Breaker. Khi nào nên dùng microservices vs monolith. Tools như Docker, Kubernetes, và service mesh.",
      image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=500&fit=crop",
      author: "Văn Đức",
      authorAvatar: "https://i.pravatar.cc/150?img=20",
      date: "14/10/2024",
      readTime: "14 phút",
      views: "980",
      tags: ["Architecture", "Backend", "Cloud"],
      category: "Lập trình",
      gradient: "from-green-600 to-teal-500"
    },
    {
      id: 6,
      title: "CSS Grid & Flexbox: Mastering Modern Layouts",
      description: "Hướng dẫn chi tiết về CSS Grid và Flexbox với interactive examples. Khi nào dùng Grid, khi nào dùng Flexbox. Responsive design patterns, common layouts, và debugging tips. Browser support và fallbacks cho older browsers.",
      image: "https://images.unsplash.com/photo-1507721999472-8ed4421c4af2?w=800&h=500&fit=crop",
      author: "Lan Anh",
      authorAvatar: "https://i.pravatar.cc/150?img=9",
      date: "13/10/2024",
      readTime: "7 phút",
      views: "1.4K",
      tags: ["CSS", "Frontend", "UI"],
      category: "Thiết kế",
      gradient: "from-yellow-600 to-orange-500"
    },
    {
      id: 7,
      title: "GraphQL vs REST: Chọn API nào cho dự án của bạn?",
      description: "So sánh chi tiết GraphQL và REST API. Ưu nhược điểm, use cases phù hợp, performance comparison. Implement GraphQL với Apollo Server và Client. Caching strategies, real-time với subscriptions. Migration từ REST sang GraphQL.",
      image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=800&h=500&fit=crop",
      author: "Quang Huy",
      authorAvatar: "https://i.pravatar.cc/150?img=13",
      date: "12/10/2024",
      readTime: "9 phút",
      views: "1.1K",
      tags: ["API", "GraphQL", "Backend"],
      category: "Lập trình",
      gradient: "from-pink-600 to-rose-500"
    },
    {
      id: 8,
      title: "Progressive Web Apps (PWA): Native-like Experience",
      description: "Xây dựng PWA với Service Workers, offline functionality, push notifications. Installable web apps, app shell architecture, caching strategies. Performance optimization và SEO benefits. Tools như Workbox và Lighthouse.",
      image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&h=500&fit=crop",
      author: "Mai Linh",
      authorAvatar: "https://i.pravatar.cc/150?img=16",
      date: "11/10/2024",
      readTime: "11 phút",
      views: "890",
      tags: ["PWA", "Mobile", "Performance"],
      category: "Công nghệ",
      gradient: "from-teal-600 to-cyan-500"
    },
    {
      id: 9,
      title: "Docker & Kubernetes: Container Orchestration Guide",
      description: "Containerization từ cơ bản đến nâng cao. Docker basics, Dockerfile best practices, multi-stage builds. Kubernetes fundamentals, deployments, services, ingress. Helm charts và GitOps. Monitoring với Prometheus và Grafana.",
      image: "https://images.unsplash.com/photo-1605745341112-85968b19335b?w=800&h=500&fit=crop",
      author: "Thành Long",
      authorAvatar: "https://i.pravatar.cc/150?img=18",
      date: "10/10/2024",
      readTime: "13 phút",
      views: "760",
      tags: ["Docker", "Kubernetes", "DevOps"],
      category: "Công nghệ",
      gradient: "from-blue-600 to-indigo-500"
    }
  ];

  const categories = [
    { name: "Tất cả", icon: "📚", count: 45 },
    { name: "Lập trình", icon: "💻", count: 18 },
    { name: "Thiết kế", icon: "🎨", count: 12 },
    { name: "Marketing", icon: "📊", count: 8 },
    { name: "Bảo mật", icon: "🔒", count: 6 },
    { name: "Công nghệ", icon: "🚀", count: 11 }
  ];

  // Popular tags
  const popularTags = [
    "React", "Next.js", "TypeScript", "Node.js", "UI/UX", 
    "SEO", "Docker", "API", "Performance", "Security"
  ];

  const filteredPosts = activeCategory === "Tất cả" 
    ? blogPosts 
    : blogPosts.filter(post => post.category === activeCategory);

  return (
    <div className="relative py-20 overflow-hidden bg-gradient-to-b from-gray-50 via-white to-gray-50">
      <div className="container relative z-10">
           <div className="container">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold color-second mb-4">
            Bài viết mới nhất
          </h2>
          <p className="text-lg color-grey max-w-2xl mx-auto">
            Cập nhật những kiến thức và xu hướng mới nhất trong lĩnh vực thiết kế và phát triển website
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex justify-center mb-10">
          <div className="flex flex-wrap gap-3">
            {categories2.map((category, index) => (
              <button
                key={index}
                className={`px-6 py-2 rounded-full border-2 transition-all duration-300 ${
                  index === 0 
                    ? 'bg-blue-500 text-white border-blue-500 hover:bg-blue-600' 
                    : 'bg-white text-gray-600 border-gray-300 hover:border-blue-500 hover:text-blue-500'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts2.map((post) => (
            <div
              key={post.id}
              className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 text-left flex flex-col h-full"
            >
              <div className="relative overflow-hidden h-48">
                <img
                  alt={post.title}
                  src={post.image}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                  width="400"
                  height="300"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-blue-600 text-white text-xs font-semibold px-2.5 py-1 rounded shadow">
                    {post.category}
                  </span>
                </div>
              </div>
              
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-lg font-bold color-second mb-3 line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3 text-sm leading-relaxed">
                  {post.description}
                </p>
                
                {/* Tags */}
                <div className="flex flex-wrap gap-2 mb-4 mt-auto">
                  {post.tags.map((tag, index) => (
                    <span key={index} className="bg-gray-100 text-gray-800 text-xs font-medium px-2 py-0.5 rounded">
                      {tag}
                    </span>
                  ))}
                </div>

                {/* Meta info */}
                <div className="flex items-center justify-between text-sm text-gray-500 pt-3 border-t border-gray-100 mt-4">
                  <div className="flex items-center gap-4">
                    <span className="flex items-center gap-1">
                      <User size={14} />
                      {post.author}
                    </span>
                    <span className="flex items-center gap-1">
                      <Calendar size={14} />
                      {post.date}
                    </span>
                  </div>
                  <span className="flex items-center gap-1">
                    <Eye size={14} />
                    {post.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        <div className="text-center mt-12">
          <button className="button-primary px-8 py-3 text-lg">
            Xem thêm bài viết
          </button>
        </div>
      </div>
        {/* Header Section */}
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center gap-2 px-6 py-2 bg-gradient-to-r from-blue-100 to-purple-100 rounded-full mb-6">
            <BookOpen size={20}  className="text-blue-600" />
            <span className="font-semibold text-blue-900">Kiến thức Website</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-black mb-6">
            <span className="bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
              Blog & Tài liệu
            </span>
          </h1>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Cập nhật kiến thức mới nhất về công nghệ web, thiết kế, và digital marketing
          </p>

          {/* Search Bar */}
          <div className="max-w-2xl mx-auto">
            <div className="flex shadow-lg rounded-xl overflow-hidden border border-gray-200">
              <div className="relative flex-1 flex items-center bg-white px-4">
                <SearchIcon size={20} className="text-gray-400 mr-2" />
                <input
                  type="text"
                  placeholder="Tìm kiếm bài viết, chủ đề..."
                  className="w-full py-3 bg-transparent text-gray-800 focus:outline-none text-base"
                />
              </div>
              <button className="bg-gradient-to-r from-blue-600 to-purple-600 border-0 text-white font-semibold px-8 py-3 transition hover:opacity-90 flex items-center justify-center">
                Tìm kiếm
              </button>
            </div>
          </div>
        </motion.div>

        {/* Hero/Featured Post */}
        <motion.div 
          className="mb-20"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden hover:shadow-purple-500/20 transition-all duration-500 group">
            <div className="grid md:grid-cols-2 gap-0">
              {/* Image Side */}
              <div className="relative h-[400px] md:h-auto overflow-hidden">
                <img 
                  src={heroPost.image} 
                  alt={heroPost.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  width="800"
                  height="500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                <div className="absolute top-6 left-6">
                  <span className="px-4 py-2 bg-gradient-to-r from-yellow-400 to-orange-500 text-white font-bold rounded-full flex items-center gap-2 shadow-lg">
                    <Star size={18} fill="currentColor" />
                    Nổi bật
                  </span>
                </div>
              </div>

              {/* Content Side */}
              <div className="p-8 md:p-12 flex flex-col justify-center">
                <span className="inline-block bg-blue-100 text-blue-800 border border-blue-200 w-fit mb-4 px-4 py-1 text-sm font-semibold rounded">
                  {heroPost.category}
                </span>
                
                <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4 line-clamp-3 group-hover:text-blue-600 transition-colors">
                  {heroPost.title}
                </h2>
                
                <p className="text-gray-600 text-lg mb-6 line-clamp-4 leading-relaxed">
                  {heroPost.description}
                </p>

                {/* Tags */}
                <div className="flex flex-wrap gap-2 mb-6">
                  {heroPost.tags.map((tag, idx) => (
                    <span key={idx} className="border border-blue-200 text-blue-700 text-xs px-2 py-0.5 rounded">
                      {tag}
                    </span>
                  ))}
                </div>

                {/* Meta Info */}
                <div className="flex items-center gap-6 mb-6 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <img src={heroPost.authorAvatar} alt={heroPost.author} className="w-6 h-6 rounded-full object-cover" width="24" height="24" loading="lazy" />
                    <span className="font-medium">{heroPost.author}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Calendar size={16} />
                    {heroPost.date}
                  </div>
                  <div className="flex items-center gap-1">
                    <Clock size={16} />
                    {heroPost.readTime}
                  </div>
                  <div className="flex items-center gap-1">
                    <Eye size={16} />
                    {heroPost.views}
                  </div>
                </div>

                <button
                  className="w-full md:w-auto px-8 bg-gradient-to-r from-blue-600 to-purple-600 text-white border-0 font-semibold hover:scale-105 transition-transform"
                >
                  Đọc ngay →
                </button>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Trending Posts Section */}
        <motion.div 
          className="mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <div className="flex items-center gap-3 mb-8">
            <Flame size={32} fill="currentColor" className="text-orange-500" />
            <h3 className="text-3xl font-black text-gray-900">Trending Now</h3>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            {trendingPosts.map((post, idx) => (
              <motion.div
                key={post.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 0.5 + idx * 0.1 }}
              >
                <div className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                  <div className="relative h-48 overflow-hidden">
                    <img 
                      src={post.image} 
                      alt={post.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      width="400"
                      height="300"
                      loading="lazy"
                    />
                    <div className={`absolute inset-0 bg-gradient-to-t ${post.gradient} opacity-60 mix-blend-multiply`}></div>
                    <div className="absolute top-4 left-4">
                      <span className="bg-red-500 text-white text-xs font-bold px-2.5 py-1 rounded">{post.category}</span>
                    </div>
                    <div className="absolute bottom-4 right-4 flex items-center gap-1 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                      <TrendingUp size={14} className="text-red-500" />
                      <span className="text-xs font-bold text-gray-800">{post.views}</span>
                    </div>
                  </div>
                  <div className="p-5">
                    <h4 className="font-bold text-gray-900 line-clamp-2 group-hover:text-blue-600 transition-colors">
                      {post.title}
                    </h4>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <div className="grid lg:grid-cols-4 gap-8">
          {/* Main Content - 3 columns */}
          <div className="lg:col-span-3">
            
            {/* Category Filter */}
            <div className="mb-12">
              <div className="flex flex-wrap gap-3">
                {categories.map((cat, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.3, delay: 0.6 + index * 0.05 }}
                  >
                    <button
                      onClick={() => setActiveCategory(cat.name)}
                      className={`px-6 py-3 h-auto rounded-xl border-2 transition-all duration-300 font-semibold flex items-center gap-2 ${
                        activeCategory === cat.name
                          ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white border-transparent shadow-lg scale-105' 
                          : 'bg-white text-gray-700 border-gray-200 hover:border-blue-500 hover:text-blue-600 hover:shadow-md hover:scale-105'
                      }`}
                    >
                      <span className="text-lg">{cat.icon}</span>
                      {cat.name}
                      <span className={`text-xs px-2 py-0.5 rounded-full ${
                        activeCategory === cat.name ? 'bg-white/20' : 'bg-gray-100'
                      }`}>
                        {cat.count}
                      </span>
                    </button>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* Blog Grid */}
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              {filteredPosts.map((post, index) => (
                <motion.div
                  key={post.id}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.7 + index * 0.1 }}
                >
                  <div className="h-full bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 group text-left flex flex-col">
                    <div className="relative h-56 overflow-hidden">
                      <img
                        alt={post.title}
                        src={post.image}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                        width="400"
                        height="300"
                        loading="lazy"
                      />
                      <div className={`absolute inset-0 bg-gradient-to-t ${post.gradient} opacity-50 mix-blend-multiply`}></div>
                      <div className="absolute top-4 left-4">
                        <span className="bg-blue-600 text-white text-xs font-semibold px-2.5 py-1 rounded shadow-md">
                          {post.category}
                        </span>
                      </div>
                      <div className="absolute top-4 right-4 flex items-center gap-1 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                        <Eye size={14} />
                        <span className="text-xs font-bold">{post.views}</span>
                      </div>
                    </div>
                    
                    <div className="p-6 flex flex-col flex-1">
                      <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-blue-600 transition-colors">
                        {post.title}
                      </h3>
                      
                      <p className="text-gray-600 mb-4 line-clamp-3 text-sm leading-relaxed">
                        {post.description}
                      </p>
                      
                      {/* Tags */}
                      <div className="flex flex-wrap gap-2 mb-4 mt-auto">
                        {post.tags.slice(0, 3).map((tag, idx) => (
                          <span key={idx} className="bg-gray-100 text-gray-800 text-xs px-2 py-0.5 rounded border border-gray-200">
                            {tag}
                          </span>
                        ))}
                      </div>

                      {/* Author & Meta */}
                      <div className="flex items-center justify-between pt-4 border-t border-gray-100 mt-4">
                        <div className="flex items-center gap-2">
                          <img src={post.authorAvatar} alt={post.author} className="w-6 h-6 rounded-full object-cover" width="24" height="24" loading="lazy" />
                          <span className="text-sm font-medium text-gray-700">{post.author}</span>
                        </div>
                        <div className="flex items-center gap-3 text-xs text-gray-500">
                          <span className="flex items-center gap-1">
                            <Clock size={14} />
                            {post.readTime}
                          </span>
                          <span>{post.date}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>

            {/* Load More */}
            <div className="text-center">
              <button
                className="px-12 py-3 h-auto text-lg font-bold rounded-xl border-0 bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300"
              >
                <span className="flex items-center gap-2">
                  Xem thêm bài viết
                  <TrendingUp size={20} strokeWidth={3} />
                </span>
              </button>
            </div>
          </div>

          {/* Sidebar - 1 column */}
          <div className="lg:col-span-1">
            <div className="sticky top-24 space-y-8">
              
              {/* Popular Tags */}
              <motion.div 
                className="bg-white rounded-2xl p-6 shadow-lg"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.8 }}
              >
                <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                  <span className="text-2xl">🏷️</span>
                  Chủ đề phổ biến
                </h4>
                <div className="flex flex-wrap gap-2">
                  {popularTags.map((tag, idx) => (
                    <span 
                      key={idx}
                      className="px-3 py-1 border border-gray-200 text-gray-600 hover:border-blue-500 hover:text-blue-600 cursor-pointer rounded transition-all hover:scale-110 text-sm"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </motion.div>

              {/* Newsletter */}
              <motion.div 
                className="bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl p-6 shadow-xl text-white"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 1 }}
              >
                <div className="text-center">
                  <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <BookOpen size={32} />
                  </div>
                  <h4 className="text-xl font-bold mb-2">Đăng ký Newsletter</h4>
                  <p className="text-sm opacity-90 mb-4">
                    Nhận bài viết mới mỗi tuần
                  </p>
                  <input 
                    type="email"
                    placeholder="Email của bạn"
                    className="w-full mb-3 rounded-lg px-4 py-2 text-gray-800 border border-gray-200 focus:outline-none text-sm"
                  />
                  <button 
                    className="w-full bg-white text-blue-600 border-0 font-semibold hover:bg-gray-100"
                  >
                    Đăng ký ngay
                  </button>
                </div>
              </motion.div>

              {/* Stats */}
              <motion.div 
                className="bg-white rounded-2xl p-6 shadow-lg"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 1.2 }}
              >
                <h4 className="text-lg font-bold text-gray-900 mb-4">Thống kê</h4>
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <span className="text-gray-600">Tổng bài viết</span>
                    <span className="font-bold text-2xl text-blue-600">156+</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-600">Lượt xem</span>
                    <span className="font-bold text-2xl text-purple-600">50K+</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-600">Độc giả</span>
                    <span className="font-bold text-2xl text-pink-600">12K+</span>
                  </div>
                </div>
              </motion.div>

            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default SectionBlogList;

